import React, {useEffect , useState} from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import axios from "axios";
import { API_URL } from "../../constent";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
  BackTo,
  PreviewCard,
  ReactDataTable,
  Row,
  Col,
} from "../../components/Component";

var userData = JSON.parse(localStorage.getItem('userData'));
var role = userData?.[0]?.role;

const handleDelete = (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this item?");
    if (confirmDelete) {
        axios.get(`${API_URL}deletcategory/${id}`).then((result)=>
        {
            console.log(result.data);
            window.location.reload();
        })
    }
};

const Category = () => {

const [policydata , SetProduct] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(()=>{
        axios.post( `${API_URL}getpolicy`).then((result)=>
        {
            console.log(result.data);
            SetProduct(result.data);
            setLoading(false);
        }) 
 },[])

 if (loading) {
    return(
       <>
         <p>Loading....</p>
       </>
    ) 
} 


  return (
    <React.Fragment>
      <Head title="Category List"/>
      <Content>
        <BlockHead size="sm">
        <Row className="g-gs">
                <Col sm="12">
                     <p className="top_head_css">Add</p>
                </Col>
          </Row>
        </BlockHead>
        <Block size="lg">
        
        {policydata.length > 0 ? (
            <ul className="category-list">
                {policydata.map((item) => (
                    <li key={item.id}><Link to={`singlecategory/${item.id}`}>{item.policy_name}</Link></li>
                ))}
            </ul>
            ) : (
                <div className="text-center">
                    <p>No data available</p>
                </div>
                )}
            </Block>

      </Content>
    </React.Fragment>
  );
};
export default Category;
